import VueTableMixin from '../tables/VueTableMixin';
import FormInput from '../forms/FormInput';

const VueTableComponentMixin = {
    extends    : VueTableMixin,
    components : { FormInput },
    computed   : {
        css () {
            return {
                tableClass       : this.tableClass,
                loadingClass     : 'loading',
                ascendingIcon    : 'blue chevron up icon',
                descendingIcon   : 'blue chevron down icon',
                ascendingClass   : 'sorted-asc',
                descendingClass  : 'sorted-desc',
                sortableIcon     : '',
                detailRowClass   : 'vuetable-detail-row',
                handleIcon       : 'grey sidebar icon',
                tableBodyClass   : 'vuetable-semantic-no-top vuetable-fixed-layout',
                tableHeaderClass : 'vuetable-fixed-layout'
            };
        }
    },
    props : {
        pageSizes                  : { type : Array, default : () => [4, 8, 12] },
        showBorder                 : { type : Boolean, default : false },
        showSearchBox              : { type : Boolean, default : true },
        showCurrentPageDataIndexes : { type : Boolean, default : true },
        paginationDesign           : { type : String, default : 'design-1' },
        tableClass                 : { type : String, default : 'table' },
        filters                    : { type : Array, default () { return []; } }
    }
};

export default VueTableComponentMixin;
